import { setCallVolume, useVoice } from '../lib/voice';
import { Icon, cx } from './ui';

/** How loud other people's voices play, up to 200% (for a quiet caller or a quiet phone). */
export function CallVolume({ className }: { className?: string }) {
  const volume = useVoice((s) => s.callVolume);
  return (
    <label className={cx('flex items-center gap-2 text-xs text-text-2', className)}>
      <Icon name="volume" className="h-4 w-4 shrink-0" />
      <input
        type="range"
        min={0}
        max={200}
        step={10}
        value={Math.round(volume * 100)}
        onChange={(e) => setCallVolume(Number(e.target.value) / 100)}
        aria-label="Call volume"
        className="min-w-0 flex-1"
      />
      <span className="w-10 shrink-0 text-right tabular-nums">{Math.round(volume * 100)}%</span>
    </label>
  );
}
